<template>
  <ItemPage
    title="Atividades"
    size="md"
    :actions="actions"
  >
    <ActivitiesFilters
      @setParameters="parameters = $event;"
    />
    <v-simple-table
      fixed-header
    >
      <template v-if="loading">
        <Loading :loading-msg="'Carregando Lista...'" />
      </template>
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="contents"
          :items-per-page="15"
          hide-default-footer
          item-key="id"
        >
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template #item.name="{ item }">
            <router-link :to="{ name: 'conteudos.atividades.id', params: { id: item.id } }">
              {{ item.name }}
            </router-link>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.created_at="{ item }">
            <span
              class="d-inline-block text-truncate"
              style="max-width: 200px;"
            >
              {{ dayjs(item.created_at).format('DD/MM/YYYY') }}
            </span>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="totalPages"
          :total-visible="5"
          class="mt-4"
        />
      </div>
    </v-simple-table>
  </ItemPage>
</template>

<script>
import CreateActivityDialog from '@/components/contents/CreateActivityDialog.vue'
import Loading from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'
import dayjs from '@/dayjs'
import ActivitiesFilters from '@/components/contents/ActivitiesFilters.vue'

export default {
  components: {
    Loading,
    ItemPage,
    ActivitiesFilters
  },

  data () {
    return {
      loading: false,
      mediaContentsView: false,
      mediaContentsCreate: false,
      contents: [],
      msg: '',
      dialogAddMediaContent: false,
      parameters: '',
      form: {
        name: ''
      },
      headers: [
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Data de cadastro',
          align: 'start',
          value: 'created_at'
        },
        {
          text: 'URL',
          align: 'start',
          value: 'url'
        }
      ],

      // Pagination
      page: 1,
      totalPages: 1
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar atividade',
          action: this.createActivity,
          icon: 'mdi-plus',
          disabled: false
        }
      ]
    }
  },
  watch: {
    page (value) {
      this.getContent(value)
    },
    async parameters () {
      this.page = 1
      await this.getContent()
    }
  },

  async mounted () {
    await this.getContent()
  },

  methods: {
    async getContent () {
      this.loading = true
      let content = []
      try {
        if (this.parameters.length === 0) {
          content = await this.$api.ListActivities(this.page)
        } else {
          content = await this.$api.ListActivities(this.page, this.parameters)
        }
        this.contents = content.data
        this.totalPages = content.meta.last_page
      } catch {
        // console.log('')
      }
      this.loading = false
    },

    typeText (typevalue) {
      const types = utils.contentType()
      return types.find(element => element.value === typevalue).typeName
    },

    async createActivity () {
      this.$dialog.custom(CreateActivityDialog).show()
        .then(async (activity) => {
          if (!activity) {
            return
          }
          await this.getContent()
        }
        )
    },

    dayjs
  }
}
</script>
